export interface Ordered {
  DisplayOrder: number;
}

interface Common extends Ordered {
  Name?: string;
  Price?: number;
  ImageUrl?: string;
  CellLayoutType: CellLayoutType | Fd.MenuSectionItemBase['CellLayoutType'];
}

export interface CuisineType {
  CuisineTypeId: number;
  Name: string;
}

export interface Language {
  LangageId: string;
  Name: string;
}

export enum OrderState {
  Created = 0,
  ReadyToProcess = 1,
  AcceptedByRestaurant = 2,
  Dispatched = 3,
  Delivered = 4,
  Cancelled = 5,
  ManualReview = 6,
  PlacedCanBeCancelled = 7,
  RejectedByRestaurant = 8,
  RejectedByFlipdish = 9,
  RejectedAutomatically = 10,
  RejectedAfterBeingAccepted = 11,
  AcceptedAndRefunded = 12,
}

export enum GatewayPaymentAccount {
  Ideal = 'Ideal',
  Sofort = 'Sofort',
  Giropay = 'Giropay',
  Eps = 'Eps',
  Alipay = 'Alipay',
  Multibanco = 'Multibanco',
  Bancontact = 'Bancontact',
  P24 = 'P24',
}

export enum WebToAppRedirect {
  NoRedirect = 0,
  RedirectOnce = 1,
  RedirectAlways = 2,
  SuggestPwa = 3,
  ForcePwa = 4,
}

export enum DayOfWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}

export enum EmailRequestMode {
  DoNotRequest = 0,
  Request = 1,
  Require = 2,
}

/*interface TimeSpan {
  Hours: number;
  Minutes: number;
  Seconds: number;
  Milliseconds: number;
  Ticks: number;
  Days: number;
  TotalDays: number;
  TotalHours: number;
  TotalMilliseconds: number;
  TotalMinutes: number;
  TotalSeconds: number;
}*/

export interface BusinessHoursPeriod {
  BusinessHoursPeriodId: number;
  DayOfWeek: DayOfWeek;
  StartTime: string;
  Period: string;
  StartTimeEarly: string | null;
  PeriodEarly: string | null;
}

export enum MenuEntityAvailabilityMode {
  DisplayAlways = 0,
  DisplayBasedOnTimes = 1,
  DisplayAlwaysStartCollapsed = 2,
  DisplayAlwaysStartCollapsedBasedOnTimes = 3,
}

export enum MenuSectionBehaviour {
  ExpandSingle = 0,
  ExpandMultiple = 1,
}

export interface MenuSectionAvailability {
  MenuSectionId: number;
  MenuSection: string | null;
  AvailableTimes: BusinessHoursPeriod[] | null;
  AvailabilityMode: MenuEntityAvailabilityMode;
}

// The values must match the server here.
export enum DeliveryType {
  Delivery = 0,
  Collection = 1, // This is called 'Pickup' on the server.
}
export enum CellLayoutType {
  Small = 0,
  Medium = 1,
  Large = 2,
}

// Matches server enum. Hard coded constants.
export enum Currency {
  EUR = 1,
  USD = 2,
  GBP = 3,
  CAD = 4,
  AUD = 5,
  DJF = 6,
  ZAR = 7,
  ETB = 8,
  AED = 9,
  BHD = 10,
  DZD = 11,
  EGP = 12,
  IQD = 13,
  JOD = 14,
  KWD = 15,
  LBP = 16,
  LYD = 17,
  MAD = 18,
  OMR = 19,
  QAR = 20,
  SAR = 21,
  SYP = 22,
  TND = 23,
  YER = 24,
  CLP = 25,
  INR = 26,
  AZN = 27,
  RUB = 28,
  BYN = 29,
  BGN = 30,
  NGN = 31,
  BDT = 32,
  CNY = 33,
  BAM = 35,
  CZK = 37,
  DKK = 39,
  CHF = 40,
  MVR = 41,
  BTN = 42,
  XCD = 43,
  BZD = 45,
  HKD = 47,
  IDR = 48,
  JMD = 49,
  MYR = 50,
  NZD = 51,
  PHP = 52,
  SGD = 53,
  TTD = 54,
  XDR = 55,
  ARS = 56,
  BOB = 57,
  COP = 58,
  CRC = 59,
  CUP = 60,
  DOP = 61,
  GTQ = 62,
  HNL = 63,
  MXN = 64,
  NIO = 65,
  PAB = 66,
  PEN = 67,
  PYG = 68,
  UYU = 69,
  VEF = 70,
  IRR = 71,
  XOF = 72,
  CDF = 73,
  XAF = 74,
  HTG = 75,
  ILS = 76,
  HRK = 77,
  HUF = 78,
  AMD = 79,
  ISK = 80,
  JPY = 81,
  GEL = 82,
  KZT = 83,
  KHR = 84,
  KRW = 85,
  KGS = 86,
  LAK = 87,
  MKD = 88,
  MNT = 89,
  BND = 90,
  MMK = 91,
  NOK = 92,
  NPR = 93,
  PKR = 94,
  PLN = 95,
  AFN = 96,
  BRL = 97,
  MDL = 98,
  RON = 99,
  RWF = 100,
  SEK = 101,
  LKR = 102,
  SOS = 103,
  ALL = 104,
  RSD = 105,
  KES = 106,
  TJS = 107,
  THB = 108,
  ERN = 109,
  TMT = 110,
  BWP = 111,
  TRY = 112,
  UAH = 113,
  UZS = 114,
  VND = 115,
  MOP = 116,
  TWD = 117,
  BMD = 118,
}

export enum ContactFormType {
  None = 0,
  Email = 1,
  Intercom = 2,
  WebView = 3,
}

export enum AddressLayoutType {
  BuildingFirst = 0,
  AddressFirst = 1,
  FullStreetAddressFirst = 2,
}

export enum ComplianceType {
  Default = 0,
  GdprCompliance = 1,
}

export interface RestaurantSummaryCommon {
  CuisineTypes: CuisineType[];
  Currency: Currency;
  IsoCurrency: string;
  IanaTimeZone: string;
  TimeZoneInfoId: string;
  PhysicalRestaurantName: string;
  VirtualRestaurantId: number;
  PhysicalRestaurantId: number;
  DistanceKm: number;
  GeneralRating?: number;
  GeneralRatingCount: number;
  UserRating?: any;
  UserRatingCount: number;
  IsOpen: boolean;
  MenuVersionNumber: number;
  AcceptPreOrders: boolean;
  MenuId: number;
  VersionGuid: string;
  MenuUrl: string;
  StripePublicKey: string;
  TableServiceCatagory: TableServiceCategory;
}

export interface CardFees {
  PercentFeeCardOrdersChargedToCustomerIncludingVat: number;
  FixedFeeCardOrdersChargedToCustomerIncludingVat: number;
  LocationServicePercentFeeCardOrdersChargedToCustomerIncludingVat: number;
  LocationServiceFixedFeeCardOrdersChargedToCustomerIncludingVat: number;
}

export interface CashFees {
  PercentFeeCashOrdersChargedToCustomerIncludingVat: number;
  FixedFeeCashOrdersChargedToCustomerIncludingVat: number;
  LocationServicePercentFeeCashOrdersChargedToCustomerIncludingVat: number;
  LocationServiceFixedFeeCashOrdersChargedToCustomerIncludingVat: number;
}

export interface Opening {
  IsOpen: boolean;
  OpenTimeHour: number;
  OpenTimeMinute: number;
  OpenTimeMessage?: string;
  SecondsUntilRestaurantOpens?: number;
  SecondsUntilRestaurantCloses?: number;
}

export interface PreOrderTime {
  Key: string;
  Value: string;
  IsFull?: boolean;
}
export interface RestaurantDetail extends CardFees, CashFees, Opening {
  AcceptCardOrders: boolean;
  AcceptCashOrders: boolean;
  AcceptPreOrders: boolean;
  AllowChefNotes: boolean;
  AppImageUrl: string;
  ChefNote?: string;
  Currency: Currency;
  DeliveryFeeTaxAmount: number;
  DisplayPhoneNumber: string;
  DisplayTax: boolean;
  FromAPI: boolean;
  MenuMessage?: string;
  MenuUrl: string;
  MenuVersionNumber: number;
  MinimumOrder: number;
  PhoneNumber: string;
  PhysicalRestaurantAddress: string;
  PhysicalRestaurantId: number;
  PreOrderOptions?: {
    PreOrderTimes: PreOrderTime[];
    RequireExplicitSelect: boolean;
  };
  ProcessingFeeTaxRate: number;
  RequireCustomerName: boolean;
  RestaurantName: string;
  TaxType: number;
  TimeZoneInfoId: string;
  TipsEnabled: boolean;
  VirtualRestaurantId: number;
}

export enum PickupLocationType {
  TakeOut = 0,
  TableService = 1,
  DineIn = 2,
}

export interface PickupLocationOption {
  PickupLocationOptionId: number;
  Value: string;
  DisplayOrder: number;
}

export enum TableServiceCategory {
  Generic = 0,
  Villa = 1,
  House = 2,
  Room = 3,
  Area = 4,
  Table = 5,
  ParkingBay = 6,
  Gate = 7,
  DriveThrough = 8,
}

// Server PickupRestaurantDetailsResponse
export interface CollectionRestaurantDetail extends RestaurantDetail {
  AllowGuestCheckout: boolean;
  AllowPreOrdersAndTableService: boolean;
  DeliveryType: DeliveryType.Collection;
  PickupLocationOptions: PickupLocationOption[];
  PickupLocationTypes: PickupLocationType[];
  TableServiceCatagory: TableServiceCategory;
}

// Server DeliveryRestaurantDetailsResponse
export interface DeliveryRestaurantDetail extends RestaurantDetail {
  UserOutsideDeliveryZone: boolean;
  DeliveryType: DeliveryType.Delivery;
  DeliveryFee: number;
}

export interface Geo {
  Longitude: number;
  Latitude: number;
}

export interface Address {
  Building: string;
  Street: string;
  Town: string;
  PostCode?: string;
}

export interface DeliveryLocation extends Address {
  AutoSelectThisLocation: boolean;
  Coordinates: Geo;
  DeliveryInstructions?: string;
  DeliveryLocationId: number;
  IsCustomAddress: boolean; // Can ignore
  IsDisplayed: boolean; // Hide false ones
}

export const BlankDeliveryLocation = function(Geo: Geo) {
  return {
    AutoSelectThisLocation: false,
    Building: '',
    Coordinates: Geo,
    DeliveryInstructions: '',
    DeliveryLocationId: -1,
    IsCustomAddress: false,
    IsDisplayed: true,
    Street: '',
    Town: '',
  };
};

// Server name: DeliveryRestaurantSummaryDm
export interface DeliveryRestaurantSummary extends RestaurantSummaryCommon {
  Name: string;
  UserOutsideDeliveryZone: boolean;
  IsFreeDelivery: boolean;
  DeliveryNote: string;
  SkipToThisVirtualRestaurant: boolean;
}

// Server name: `PickupPhysicalRestaurantSummaryItem`
export interface CollectionRestaurantSummary extends RestaurantSummaryCommon {
  PhysicalRestaurantId: number;
  SkipToThisPhysicalRestaurant: boolean;
  VirtualRestaurantName: string;
  PickupLocationTypes: PickupLocationType[];
  IncludePhysicalRestaurantIds: string;
}

export interface PhoneNumberConfig {
  Prefix: string;
  AutocompletePhoneNumberLength: number;
}

export interface EnterPhoneNumberScreenTermsMessage {
  LinkText: string;
  LinkUrl: string;
  Text: string;
}

// AppDesignScheme to theme map
// isDark: theme.palette.type === 'dark'
// Primary: theme.palette.background.default,
// Secondary: theme.palette.primary.main,
// Tertiary: theme.palette.background.default,
// Font: theme.typography.fontFamily
export interface AppDesignScheme {
  Primary: string;
  Secondary: string;
  Tertiary: string;
  Font?: string;
}

type PostCodeInputLabel = string | null;

export interface AppConfig {
  AppNameId: string;
  WhiteLabelId: number;
  AppStoreId: string;
  AppStoreUrl: string | null;
  BrandName: string | null;
  BrandLogoUrl: string | null;
  PlayStoreUrl: string | null;
  ContactFormType: ContactFormType;
  DeliveryEnabled: boolean;
  DeliveryAddressLayout: number;
  // Unused - DisplayBumpSideMenuItem
  DisplayCuisineTypeListAndRestaurantSearchBar: boolean;
  DisplayDeliveryRestaurantListScreen: boolean;
  DisplayFreeCokeSideMenuItem: boolean;
  DisplayPickupRestaurantListScreen: boolean;
  DisplayUserRestaurantRatings: boolean;
  IntercomAppId: string;
  IntercomToken: string;
  GoogleAnalyticsTokens: string[];
  FacebookTokens: string[];
  Features: string[];
  ComplianceType: ComplianceType;
  MapBoundryMaxLatitude: number;
  MapBoundryMaxLongitude: number;
  MapBoundryMinLatitude: number;
  MapBoundryMinLongitude: number;
  MapCenterLatitude: number;
  MapCenterLongitude: number;
  MixpanelToken: string;
  PickupEnabled: boolean;
  DineInEnabled: boolean;
  ShareMessageEmailMessage?: string;
  ShareMessageEmailSubject?: string;
  ShareMessageEmailUrl?: string;
  ShareMessageFacebookMessage?: string;
  ShareMessageFacebookUrl?: string;
  ShareMessageGenericMessage?: string;
  ShareMessageGenericUrl?: string;
  ShareMessageSmsMessage?: string;
  ShareMessageSmsUrl?: string;
  ShareMessageTwitterMessage?: string;
  ShareMessageTwitterUrl?: string;
  ShareMessageWhatsAppMessage?: string;
  ShareMessageWhatsAppUrl?: string;
  PhoneNumberConfig: PhoneNumberConfig;
  PostCodeInputLabel: PostCodeInputLabel;
  EnterPhoneNumberScreenTermsMessage: EnterPhoneNumberScreenTermsMessage;
  Category: number;
  WebToAppRedirect: WebToAppRedirect;
  TipsEnabled: boolean;
  Languages: [Language];
  AppDesignScheme: AppDesignScheme;
  CookiePolicyUrl?: string;
  PrivacyPolicyUrl?: string;
  TermsAndConditionsUrl?: string;
}

export interface MenuItemOptionSetItem extends Common {
  MenuItemOptionSetItemId: number;
  NextMenuItemOptionSetId?: number;
  IsAvailable: boolean;
  TaxValue?: number;
}

export interface MenuItemOptionSet extends Common {
  MenuItemOptionSetId: number;
  IsMasterOptionSet: boolean;
  MinSelectCount: number;
  MaxSelectCount: number;
  MenuItemOptionSetItems: MenuItemOptionSetItem[];
}

export interface MenuItem extends Common {
  ActualPrice: number;
  Alcohol: boolean;
  Description?: string;
  DisableVouchers: boolean;
  IsAvailable: boolean;
  MenuItemId: number;
  MenuItemOptionSets: MenuItemOptionSet[];
  TaxValue: number;
}

export interface ConcessionStore {
  ConcessionStoreId: number;
  Name: string;
  Description: string;
  ImageName: string;
  ImageUrl: string;
}

export interface ReadonlyMenuResponse {
  MenuId: number;
  VersionNumber: number;
  MenuSections: any[];
  DisplaySectionLinks: boolean;
  MenuSectionBehaviour: Fd.Menu['MenuSectionBehaviour'];
  FromAPI: boolean;
  Locked: boolean;
}

export interface MenuReposnse {
  VirtualRestaurantId: number;
  MenuId: number;
  MenuVersionNumber: number;
  MenuSections: any[];
  Currency: Currency;
  DisplaySectionLinks: boolean;
  MenuSectionBehaviour: MenuSectionBehaviour;
  FromAPI: boolean;
  VersionGuid: string;
  MenuUrl: string;
  ConcessionStores: ConcessionStore[];
}

export interface Customer {
  ConsentRequest: ConsentRequestData;
  CustomerName: string | null;
  CustomerPhoneNumberLocalFormatString: string;
  DefaultTipPercentage: number;
  DisplayTipOption: boolean;
  EmailAddress: string | null;
  EmailRequestMode: EmailRequestMode;
  IsGuest: boolean;
  Language: string;
  PhoneNumber: string;
  RequireAgeConfirmationForAlcoholOrdersData: RequireAgeConfirmationForAlcoholOrdersData;
  SmsPromotionsEnabled: boolean;
  UserId: number;
}

export interface RequireAgeConfirmationForAlcoholOrdersData {
  ConfirmButtonText: string;
  DenyButtonText: string;
  MessageText: string;
  DisplayConfirmationPrompt: boolean;
}

export interface ConsentRequestData {
  RequestConsent: boolean;
  MessageText: string | null;
  ConfirmButtonText: string | null;
  DenyButtonText: string | null;
  SmallPrintText: string | null;
  SmallPrintUrl: string | null;
}

export interface PaymentAccount {
  UserId: number;
  PaymentAccountId: number;
  CanRemoveFromCustomerView: boolean;
  Bin?: string;
  IsDefaultPaymentMethod: boolean;
  PaymentAccountType:
    | 'CardPaymentAccount'
    | 'CashPaymentAccount'
    | 'BrainTreePayPalPaymentAccount'
    | 'StripePayButtonPaymentAccount'
    | GatewayPaymentAccount;
  CustomerId: string;
  TokenizationKey: string;
  PublicApiKey: string;
  Description: string;
  SupportsSubmitOrderTips: boolean;
}

export interface PreviousOrderItemOptionDm {
  MenuItemOptionId: number;
  IsMasterOptionSetItem: boolean;
  Name: string;
  Price: number;
  MenuItemOptionDisplayOrder: number;
  MenuItemOptionSetDisplayOrder: number;
}

export interface PreviousOrderItemVms {
  VirtualRestaurantId: number;
  MenuSectionName: string;
  MenuSectionId: number;
  Name: string;
  Description: string;
  Price: number;
  PriceIncludingOptionSetItems: number;
  OrderItemId: number;
  MenuItemId: number;
  IsAvailable: boolean;
  PreviousOrderItemOptionVms: PreviousOrderItemOptionDm[];
  MenuSectionDisplayOrder: number;
  MenuItemDisplayOrder: number;
}

export interface CustomerOrderView {
  OrderId: number;
  VirtualRestaurantId: number;
  PhysicalRestaurantId?: number;
  DeliveryType: DeliveryType;
  RestaurantName: string;
  TipAmount: number;
  DeliveryAmount: number;
  FoodAmount: number;
  CardFee: number;
  TotalAmount: number;
  TsEditTipEndTimeUtc?: string; // time object
  TsUpdate: string; // time object
  UserRating?: number;
  CuisineType: CuisineType;
  PaymentAccountDescription: string; // Visa **** 2371. or Apple Pay. or Cash
  PreviousOrderItemVms: PreviousOrderItemVms[];
  IsHiddenFromRecentOrdersList: boolean;
  Currency: Currency;
  TsOrderPlaced: string; // date object
  DeliveryLocationAddressString: string; // eg. 20 Waterloo Road
  DeliveryLocationId?: number;
  DeliveryInstructions: string;
  CoordinatesDm: Geo;
  OrderState: OrderState;
}

export interface CreatedOrder {
  SaveOrderResponseStatus: number;
  OrderId: number;
  VoucherBasketItems: VoucherBasketItemDm[];
}

// Send order

// { "MenuItemId": 213896, "MenuItemOptionSetItemIds": [1054985, 1054991, 1054999] }
export interface OrderItem {
  MenuItemId: number;
  MenuItemOptionSetItemIds: number[];
}

// TODO: Only some of these are necessary.
export interface OrderBase {
  VirtualRestaurantId: number;
  deviceId: string; // UUID
  OrderItemVms: OrderItem[];
  TipAmount: number;
  DeliveryType: DeliveryType;
  RequestedDeliveryOrPickupTimeUtc?: string | null;
  MenuId?: number;
  VersionGuid?: string;
  PaymentAccountId?: number;
}

export interface DeliveryOrder extends OrderBase {
  DeliveryLocationId: number;
  UserLocation?: Geo;
}

export interface CollectionOrder extends OrderBase {
  PhysicalRestaurantId: number;
  PickupLocationType: PickupLocationType;
  PickupLocationId?: number;
  TableServiceCatagory?: TableServiceCategory;
}

export interface DeliveryLocationResponse {
  SkipToDeliveryRestaurantsScreen: boolean;
  SkipToPickupRestaurantsScreen: boolean;
  DeliveryLocations: DeliveryLocation[];
}

export interface VoucherBasketItemDm {
  Name: string;
  Description: string;
  Amount: number;
  TaxAmount: number;
}

export interface ApplyVoucherProps {
  orderId: number;
  voucherCode: string;
  paymentAccountId?: number;
}

export interface SubmitOrderBase {
  orderId: number;
  chefNote: string;
  refererUrl?: string;
}
export interface SubmitOrderProps extends SubmitOrderBase {
  paymentAccountId: number;
}
export interface SubmitPayPalOrderProps extends SubmitOrderBase {
  clientToken: string;
  deviceData: string;
}
export interface SubmitPayStripeOrderProps extends SubmitOrderBase {
  stripePaymentMethodId: string;
  physicalRestaurantId?: number;
}
export interface SubmitOrderResponseDm {
  OrderId: number;
  LocalOrderId: string;
  DeliveryTimeEstimateMinutes?: number | null;
  OrderPlacedMessage: string;
  DisplayTipControl: boolean;
  DisplayRateAppControl: boolean;
  CancelOrderPeriodSeconds?: number | null; // If null then don't display cancel control to user.

  RestaurantName: string;
  LinkText: string;
  LinkUrl: string;
  DeliveryType: DeliveryType;
  // DuringOrderPromotionOptions: DuringOrderPromotionOptionsDm;

  // #region Redirect payment methods only

  RedirectUri: string;

  // #endregion

  // #region Pickup Only
  PickupCode: string; // the code to display when picking up order
  RestaurantAddress: string;

  // #endregion
}

export interface PreviousOrderItemDm {
  MenuItemPublicId: string;
  MenuSectionPublicId: string;

  VirtualRestaurantId: number;
  MenuSectionName: string;
  MenuSectionId: number;
  Name: string;
  Description: string;
  Price: number;
  PriceIncludingOptionSetItems: number;
  OrderItemId: number;
  MenuItemId: number;
  IsAvailable: boolean;
  PreviousOrderItemOptionVms: PreviousOrderItemOptionDm[];
  MenuSectionDisplayOrder: number;
  MenuItemDisplayOrder: number;

  IsVoucher: boolean;

  Metadata: { [key: string]: string };
}
export interface CoordinatesDm {
  Latitude: number;
  Longitude: number;
}
export enum RejectionReason {
  TooBusy = 0,
  FoodUnavailable = 1,
  UnableToDeliver = 2,
  UnknownAddress = 3,
  UnknownReason = 4,
  TooSoon = 5,
  TimeUnavailable = 6,
  DontDeliverToArea = 7,
  RestaurantUncontactable = 8,
}
export enum PaymentAccountType {
  Card = 0,
  Cash = 1,
  EMV = 2,
  External = 3,
  PayButton = 4,
  PayPal = 5,
}
export enum Warning {
  InsideFraudZone = 1,
  UnusuallyHighValueOrder = 2,
}
export enum DeliveryTrackingStatus {
  /**Not assigned to driver */
  Unassigned = 10,
  /**Assigned but not accepted */
  Unaccepted = 15,
  /**Accepted by driver */
  Accepted = 20,
  /**Carrying */
  Carrying = 30,
  /**On the way */
  OnTheWay = 60,
  /**Arrived at location */
  ArrivedAtLocation = 70,
  /**Delivered */
  Delivered = 80,
  /**Cannot deliver */
  CannotDeliver = 90,
}

export interface PreviousOrderDm {
  OrderId: number;
  LocalOrderId: string;
  VirtualRestaurantId: number;
  WhiteLabelId: number;
  UserId: number;
  PhysicalRestaurantId: number | null;
  DeliveryType: DeliveryType;
  PickupLocationType: PickupLocationType;
  PickupLocationId: number | null;
  PickupLocationOptionValue: string;
  TableServiceCatagory: TableServiceCategory;
  RestaurantName: string;
  TipAmount: number;
  DeliveryAmount: number;
  FoodAmount: number;
  CardFee: number;
  ProcessingFee: number;
  TotalAmount: number; // TotalCustomerAmount
  TsEditTipEndTimeUtc: Date | string | null;
  TsUpdate: Date | string;

  // response for 3d secure failure
  PaymentProcessingResponse: string | null;

  UserRating: number | null;

  CuisineType: CuisineType;
  /**Visa **** 2371. or Apple Pay. or Cash */
  PaymentAccountDescription: string;

  IsExternalPaymentAccountType: boolean;

  PreviousOrderItemVms: PreviousOrderItemDm[];

  IsHiddenFromRecentOrdersList: boolean;

  Currency: Currency;
  IsoCurrency: string;

  TsOrderPlaced: Date | string | null;

  DeliveryLocationAddressString: string; // eg. 20 Waterloo Road

  DeliveryLocationId: number | null;

  DeliveryLocation: DeliveryLocation;

  DeliveryInstructions: string;
  PhysicalRestaurantCoordinates: CoordinatesDm;
  Coordinates: CoordinatesDm;
  UserLocation: CoordinatesDm;

  MenuId: number;

  RejectionReason: RejectionReason | null;
  KioskCustomerName: string;

  // #region RestaurantOrders

  TotalRestaurantAmount: number;

  PaymentAccountType: PaymentAccountType;

  OrderState: OrderState;

  CustomerName: string;

  EmailAddress: string;

  IsPreOrder: boolean;

  TsRequestedFor: Date | string | null;

  AmendmentForOrderId: number | null;

  HasAmendmentOrder: boolean;

  PreviousOrdersAtPhysicalRestaurantCount: number;
  PhysicalRestaurantTimeZoneInfoId: string;
  ChefNote: string;
  NetTipAmount: number;
  // Voucher: Voucher;
  VoucherAmount: number | null; // Eg. €5 off voucher will have an amount of -5.00
  // AppType: AppType;
  // PrintoutLayoutType: PrintoutLayoutType;
  UserMetadata: { [key: string]: string };
  PhysicalRestaurantMetadata: { [key: string]: string };

  Warnings: Warning;

  FoodTaxAmount: number;
  TotalTax: number;
  TipTaxAmount: number;
  DeliveryTaxAmount: number;
  // #endregion

  RefundedAmount: number | null;
  WasRedirectRequired: boolean;

  /**Delivery tracking status */
  DeliveryTrackingStatus: DeliveryTrackingStatus | null;

  /**Assigned driver identifier */
  DriverId: number | null;

  /**Time that the order was accepted for by store */
  AcceptedFor: Date | string | null;

  /**Id of user who rejected order */
  RejectedByUserId: number | null;
}

// Common reposonse JSON
export interface Result<T> {
  Success: boolean;
  Data: T;
  UserMessage: string;
  DeveloperMessage: string;
  StackTrace: string;
}
